import axiosInstance from "@/api/axiosInstance";

export class InvitationService {
  public async createInvitation(): Promise<string> {
    const response = await axiosInstance.post("/api/v1/admin/invitations");
    return response.data.token;
  }

  public async validateToken(token: string): Promise<void> {
    await axiosInstance.get("/api/v1/register/validate", { params: { token } });
  }

  public async register(data: {
    token: string;
    companyName: string;
    address: string;
    phone: string;
    email: string;
    taxNumber: string;
    bankAccount: string;
    bankName: string;
    billingAddress: string;
    adminFirstName: string;
    adminLastName: string;
    adminEmail: string;
    adminPassword: string;
  }): Promise<void> {
    await axiosInstance.post("/api/v1/register", data);
  }

  public async confirmEmail(token: string): Promise<void> {
    await axiosInstance.get("/api/v1/register/confirm", { params: { token } });
  }
}
